import Elevenlabs from "./Elevenlabs";
import RimeAI from "./RimeAI";
import GoogleTTS from "./GoogleTTS";
import AzureTTS from "./AzureTTS";
import Cartesia from "./Cartesia";
import SuperdashTTS2 from "./SuperdashTTS2";

enum TTSProvider {
  Elevenlabs = "elevenlabs",
  Azure = "azuretts",
  Google = "googletts",
  RimeAI = "rimeai",
  Cartesia = "cartesia",
  // Loudness settings exist only for TTS2 (OmniVoice) — its server holds the
  // full utterance before streaming so it can normalize; TTS1 (VoxCPM)
  // streams while generating and has no loudness settings.
  SuperdashTTS2 = "superdashtts2",
}

const TTSProviderSettings = {
  [TTSProvider.Elevenlabs]: (props) => <Elevenlabs {...props} />,
  [TTSProvider.Azure]: (props) => <AzureTTS {...props} />,
  [TTSProvider.Google]: (props) => <GoogleTTS {...props} />,
  [TTSProvider.RimeAI]: (props) => <RimeAI {...props} />,
  [TTSProvider.Cartesia]: (props) => <Cartesia {...props} />,
  [TTSProvider.SuperdashTTS2]: (props) => <SuperdashTTS2 {...props} />,
};

export { TTSProviderSettings, TTSProvider };
